module.exports = __webpack_public_path__ + "img/index01-En1.d87d616d.jpg";